import trtEnhanced from './initial/Enhanced/flow';
import trtEnhancedFollowup from './followup/Enhanced/flow';
import trtFollowup from './followup/flow';

const trtFlows = { trtEnhanced, trtFollowup, trtEnhancedFollowup };

export default trtFlows;
